import { NavLink } from "react-router-dom";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

export function IconAction({ label, icon: Icon, onClick, to, testId, danger }) {
  const cls = cn("flex h-9 flex-1 items-center justify-center rounded-lg border transition-colors",
    danger ? "border-red-500/40 text-red-500 hover:bg-red-500/10" : "text-muted-foreground hover:bg-accent hover:text-foreground");
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        {to
          ? <NavLink to={to} aria-label={label} className={cls} data-testid={testId}><Icon className="h-4 w-4" /></NavLink>
          : <button type="button" onClick={onClick} aria-label={label} className={cls} data-testid={testId}><Icon className="h-4 w-4" /></button>}
      </TooltipTrigger>
      <TooltipContent side="bottom" data-testid={`${testId}-tooltip`}>{label}</TooltipContent>
    </Tooltip>
  );
}
